import 'core-js/features/string';
import 'core-js/features/object';
import 'core-js/features/array';

import 'lazysizes';

import 'lazysizes/plugins/progressive/ls.progressive';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import './vue';
import './cookieconsent';
import './display-menu-on-scroll';
